import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ReciclagemPage } from "./reciclagem";

import { ParticipacaoProvider } from "../../providers/participacao/partipacao.provider";
import { ResiduoProvider } from "../../providers/reciclagem/residuo.provider";
import { ReciclagemProvider } from "../../providers/reciclagem/reciclagem.provider";
import { ReciclagemReciboModule } from "./reciclagem-recibo/reciclagem-recibo.module";
import { ReciclagemHistoricoModule } from "./reciclagem-historico/reciclagem-historico.module";
import { ReciclagemOrigemPageModule } from "./reciclagem-origem/reciclagem-origem.module";
import { ContratoProvider } from "../../providers/contrato/contrato.provider";
import { VeiculoProvider } from "../../providers/veiculo/veiculo.provider";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  declarations: [ReciclagemPage],
  imports: [
    IonicPageModule.forChild(ReciclagemPage),
    PipesModule,
    ReciclagemReciboModule,
    ReciclagemHistoricoModule,
    ReciclagemOrigemPageModule,
  ],
  providers: [
    ParticipacaoProvider,
    ResiduoProvider,
    ReciclagemProvider,
    ContratoProvider,
    VeiculoProvider,
  ],
})
export class ReciclagemPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem.module.ts